import React from 'react';
export const Member = (props) => {
    return <>{props.children}</>;
};
